import { MetricPeriodTypeCdEnum } from '../../app/service/models/expApiTypes'

export abstract class AppConstants {
	// Backend session max age: Active users can work for up to 8 hours with auto token refresh
	public static readonly SESSION_MAX_AGE_SEC = 8 * 60 * 60

	// Warning modal appears 30 seconds before automatic logout
	public static readonly SESSION_WARNING_BEFORE_TIMEOUT_SEC = 30

	public static readonly ONE_DAY_MS = 24 * 60 * 60 * 1000

	public static readonly QUERY_PARAM_VALUE_BROKER = 'BROKER'

	public static readonly ON_MARKET_STATUS_ITEMS = [
		{ label: 'Active', value: 'ACTV', disabled: false },
		{ label: 'Pending', value: 'PEND', disabled: false },
		{ label: 'Pre-listing', value: 'PREL', disabled: false },
	]
	public static readonly OFF_MARKET_STATUS_ITEMS = [
		{ label: 'Canceled', value: 'CNCL', disabled: false },
		{ label: 'Expired', value: 'EXPR', disabled: false },
		{ label: 'Withdrawn', value: 'WDRW', disabled: false },
	]
	public static readonly ON_MARKET_STATUS_ITEMS_TRANSACTION = [
		{ label: 'Pending', value: 'PEND', disabled: false },
		{ label: 'Closed', value: 'CLOS', disabled: false },
	]
	public static readonly LOADING_STATES = ['loading', 'errored', 'success']
	public static readonly PAGINATION_THRESHOLD = 7
	public static readonly PAGINATION_VARIANTS = {
		default: 'default',
		inputPagination: 'inputPagination',
	}
	public static readonly PROSPECT_PIPELINE_WARNING_LIMIT = 180
	public static readonly PROSPECT_PIPELINE_MAX_LIMIT = 200
	public static readonly NURTURING_PIPELINE_WARNING_LIMIT = 270
	public static readonly NURTURING_PIPELINE_MAX_LIMIT = 300
	public static readonly DATA_THRESHOLD_LIMIT = 7
	public static readonly RETRY_BASE_DELAY_MS = 1000
	public static readonly RETRY_MAX_ATTEMPTS = 3
	public static readonly MLS_STATUS_OPTIONS = [
		{ label: 'All', value: '' },
		{ label: 'Active', value: 'ACTV' },
		{ label: 'Inactive', value: 'NACTV' },
	]
	public static readonly REP_FOCUS_CODES = [
		{ label: 'No selection', value: 'None' },
		{ label: 'Seller', value: 'SELL' },
		{ label: 'Buyer', value: 'BUY' },
		{ label: 'Buyer/Seller', value: 'BAL' },
	]

	public static getRepFocusLabel(value: string): string | undefined {
		const item = AppConstants.REP_FOCUS_CODES.find(code => code.value === value)
		return item?.label
	}
	public static readonly MONTH_LIST = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	]
	public static readonly TRANSACTION_STATUS_LIST = [
		{ label: 'Active', value: 'ACTIVE' },
		{ label: 'Pending', value: 'PENDING' },
		{ label: 'Closed', value: 'CLOSED' },
		{ label: 'Withdrawn', value: 'WITHDRAWN' },
	]
	public static readonly PROPERTY_TYPE_LIST = [
		{ label: 'Commercial', value: 'COMMERCIAL' },
		{ label: 'Condos/Co-ops', value: 'COOP' },
		{ label: 'Land', value: 'LAND' },
		{ label: 'Mobile home', value: 'MOBILE' },
		{ label: 'Multi-family', value: 'MFR' },
		{ label: 'Single family', value: 'SFR' },
		{ label: 'Townhome', value: 'TOWNHOUSE' },
		// { label: 'Condo', value: 'CONDO' },
	]
	public static readonly REPRESENTATION_SIDE_LIST = [
		{ label: 'No selection', value: 'none' },
		{ label: 'Buyer', value: 'BUY' },
		{ label: 'Seller', value: 'SELL' },
		{ label: 'Buyer/Seller', value: 'BOTH' },
	]

	public static readonly TIMEFRAME_OPTIONS = [
		{
			label: 'Last 12 months (LTM)',
			value: MetricPeriodTypeCdEnum.LTM,
		},
		{
			label: 'Year to date (YTD)',
			value: MetricPeriodTypeCdEnum.YTD,
		},
		{
			label: 'Last 5 years (L5Y)',
			value: MetricPeriodTypeCdEnum.L5Y,
		},
	]

	public static readonly MLS_MAX_RESULTS_CAP = 500
	public static readonly TABLE_MAX_RESULTS_CAP = 1000

	public static readonly TODO_TYPE_LIST = [
		{ label: 'Call', value: 'CALL' },
		{ label: 'Text', value: 'MSG' },
		{ label: 'Email', value: 'EMAIL' },
		{ label: 'Other', value: 'OTHER' },
	]
	public static readonly RECRUITING_ENGAGEMENT_PAGE_SIZES = {
		NOTES_PAGE_SIZE: 3,
		LOGS_PAGE_SIZE: 10,
		EVENTS_PAGE_SIZE: 3,
		TODOS_PAGE_SIZE: 3,
	} as const
}
